import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Help from '../views/Help.vue'
//import Model from '../views/Model.vue'
import Help from "../views/Help";

Vue.use(VueRouter);

const routes = [
    // 01 Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start',
            metaTags: [
                {
                    name: 'description',
                    content: 'Interaktive 3D Story über den Brand von Notre Dame'
                },
                {
                    name: 'og:description',
                    content: 'Interaktive 3D Story über den Brand von Notre Dame'
                },
                {
                    name:'og:image',
                    content: 'LinkZumBild'
                }
            ]
        }
    },
    // 02 Hilfe
    {
        path: '/help',
        component: Help
        //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    },
    //03 Modell
    //{
    //    path: '/model',
    //    component: Model,
    //    //component: () => import(/* webpackChunkName: "model" */ '../views/About.vue')
    //    meta: {
    //        title: 'Model Only'
    //    }
    //},
    // 04 Sperrzone
    {
        path: '/Sperrzone',
        component: () => import(/* webpackChunkName: "intro" */ '../views/000_Sperrzone.vue'),
        meta: {
            title: 'Sperrzone'
        }
    },
    // 05 Zeitsprung 1986
    {
        path: '/1986',
        component: () => import(/* webpackChunkName: "intro2" */ '../views/001_Jahr_1986.vue')
    },    
    // 06 Explosion
    {
        path: '/Explosion',
        component: () => import(/* webpackChunkName: "intro" */ '../views/002_Explosion.vue')
    },
    // 07 Gruende
    {
        path: '/Gründe',
        component: () => import(/* webpackChunkName: "intro2" */ '../views/003_Gruende.vue')
    },
    // 06 Wolke
    {
        path: '/Wolke',
        component: () => import(/* webpackChunkName: "roof" */ '../views/004_Wolke.vue')
    },
    //  07 Betonsarkophag
    {
        path: '/Betonsarkophag',
        component: () => import(/* webpackChunkName: "fire" */ '../views/005_Betonsarkophag.vue')
    },
    //  08 Rostiger Betonsarkophag
    {
        path: '/BetonsarkophagRost',
        component: () => import(/* webpackChunkName: "fire" */ '../views/006_BetonsarkophagRost.vue')
    },

    //  09 New Safe Confinenement
    {
        path: '/NSC',
        component: () => import(/* webpackChunkName: "fire" */ '../views/007_NSC.vue')
    },

    //  10 New Safe Confinenement Grösse
    {
        path: '/NSC_Groesse',
        component: () => import(/* webpackChunkName: "fire" */ '../views/008_NSC_Groesse.vue')
    },

    //  11 Elbphilharmonie
    {
        path: '/Elbphilharmonie',
        component: () => import(/* webpackChunkName: "fire" */ '../views/009_Elbphilharmonie.vue')
    },
    
    //  12 NSC Animation
    {
        path: '/NSCAnimation',
        component: () => import(/* webpackChunkName: "fire" */ '../views/010_NSC_Anim.vue')
    },

    //  13 NSC Innen
    {
        path: '/NSCInnen',
        component: () => import(/* webpackChunkName: "fire" */ '../views/011_NSC_Innen.vue')
    },

    //  14 Touristen
    {
        path: '/Touristen',
        component: () => import(/* webpackChunkName: "fire" */ '../views/012_Touristen.vue')
    },

    //  15 Credits
    {
        path: '/Abspann',
        component: () => import(/* webpackChunkName: "fire" */ '../views/013_Credits.vue')
    },
];

const router = new VueRouter({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
